import React from 'react';
import PropTypes from 'prop-types';
import { formatStake } from '../../utils/money';

const StakeCell = ({ stake }) => (stake <= 0 ?
    formatStake(stake) : <strong>{formatStake(stake)}</strong>);

StakeCell.propTypes = {
    stake: PropTypes.oneOfType([
        PropTypes.number, PropTypes.string,
    ]),
};

export default StakeCell;



// WEBPACK FOOTER //
// ./src/js/shared/cells/StakeCell.jsx